module.exports = __webpack_public_path__ + "static/media/recruitbannerbg.062a343d.png";